import { render } from "./SponsorHero.vue?vue&type=template&id=99a74bf2&scoped=true"
import script from "./SponsorHero.vue?vue&type=script&lang=js"
export * from "./SponsorHero.vue?vue&type=script&lang=js"

import "./SponsorHero.vue?vue&type=style&index=0&id=99a74bf2&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a74bf2"]])

export default __exports__